export const getReviews = async ({
  dispatchAPI,
  supervision,
  setReviews,
  user,
  setUserAlreadySendReview,
  form,
  message
}) => {
  try {
    const { data } = await dispatchAPI('GET', {
      url: `/ratings?supervision=${supervision?._id}&populate=author.id,receiver.id`
    });
    setReviews(data);

    if (data.length) {
      // `author.id` comes back populated: an Owner/Pensioner profile (with its
      // `user`) or, without profile, the User itself. Match on the user id so
      // a second pensioner on the same supervision can still leave a review.
      const existingRewiew = data.filter((review) => {
        const author = review.author?.id;
        const authorUserId = author?.user ?? author?._id ?? author;
        return (
          authorUserId != null && String(authorUserId) === String(user._id)
        );
      });
      if (existingRewiew.length) {
        setUserAlreadySendReview(true);
        form.setFieldsValue(existingRewiew[0]);
      }
    }
  } catch (e) {
    message(e);
  }
};
